import afterpay from '../Images/afterpay-logo-png-black-transparent.png'
import Bupa from '../Images/Bupa-Logo.jpg.png'
import cbhs from '../Images/cbhs-logo.png'
import denticare from '../Images/download.png'
import eftpos from '../Images/EFTPOS_Logo.svg.png'
import hcf from '../Images/HCFMoreForTeeth.jpeg.png'
import hicaps from '../Images/hicaps.png'
import medibank from '../Images/medibank-logo.png'
import medicare from '../Images/Medicare-Hours.jpg.png'
import mysmile from '../Images/my-smile-plan.png'
import smile from '../Images/Smile.png'
import westfund from '../Images/westfund.png'

const data = [
    {
        id:"payment-opt-1",
        image: afterpay,
    },
    {
        id:"payment-opt-2",
        image: Bupa,
    },
    {
        id:"payment-opt-3",
        image: cbhs,
    },
    {
        id:"payment-opt-4",
        image: denticare,
    },
    {
        id:"payment-opt-5",
        image: eftpos,
    },
    {
        id:"payment-opt-6",
        image: hcf,
    },
    {
        id:"payment-opt-7",
        image: hicaps,
    },
    {
        id:"payment-opt-8",
        image: medibank,
    },
    {
        id:"payment-opt-9",
        image: medicare,
    },
    {
        id:"payment-opt-10",
        image: mysmile,
    },
    {
        id:"payment-opt-11",
        image: smile,
    },
    {
        id:"payment-opt-12",
        image: westfund,
    }
];

export default data